import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
export interface UserInfo {
  id?: string;
  name?: string;
  email?: string;
  homedir?: string;
  hostname?: string;
  platform?: string;
  release?: string;
  username?: string;
}
interface AuthState {
  // State
  isLoggedIn: boolean;
  userInfo: UserInfo | null;
  loginUrl: string;
  isAuthInitializing: boolean;
  authPromise: Promise<{ isLoggedIn: boolean }> | null;
  // Actions
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  setUserInfo: (userInfo: UserInfo | null) => void;
  setLoginUrl: (loginUrl: string) => void;
  setIsAuthInitializing: (isInitializing: boolean) => void;
  setAuthPromise: (promise: Promise<{ isLoggedIn: boolean }> | null) => void;
  logout: () => void;
}
export const useAuthStore = create<AuthState>()(
  devtools(
    set => ({
      // Initial state
      isLoggedIn: false,
      userInfo: null,
      loginUrl: '',
      isAuthInitializing: false,
      authPromise: null,
      // Actions
      setIsLoggedIn: isLoggedIn => set({ isLoggedIn }),
      setUserInfo: userInfo => set({ userInfo }),
      setLoginUrl: loginUrl => set({ loginUrl }),
      setIsAuthInitializing: isInitializing =>
        set({ isAuthInitializing: isInitializing }),
      setAuthPromise: promise => set({ authPromise: promise }),
      logout: () => {
        // 🔥 退出时断开 socket.io 连接
        import('@/lib/socket').then(mod => mod.default.disconnect());
        set({
          isLoggedIn: false,
          userInfo: null,
          authPromise: null,
        });
      },
    }),
    { name: 'AuthStore' }
  )
);
